import React, { ReactNode } from 'react'
import { motion } from 'framer-motion'
import { generalVariants, lastItemsVariants } from './utils'

interface ListItemAnimationProps {
  index: number
  reference: string
  listLength: number
  children: ReactNode
  hasLoadedMore: boolean
  isLastTwo: boolean
  isNextToAnimate: boolean
}

export const ListItemAnimation = ({
  index,
  reference,
  listLength,
  hasLoadedMore,
  isLastTwo,
  isNextToAnimate,
  children,
}: ListItemAnimationProps) => {
  return (
    <motion.li
      key={`${reference}-${index}`}
      initial={
        hasLoadedMore &&
        (isLastTwo ? lastItemsVariants.initial : isNextToAnimate && generalVariants.initial)
      }
      animate={
        hasLoadedMore &&
        (isLastTwo ? lastItemsVariants.animate : isNextToAnimate && generalVariants.animate)
      }
      exit={
        hasLoadedMore &&
        (isLastTwo ? lastItemsVariants.exit : isNextToAnimate && generalVariants.exit)
      }
      transition={{
        duration: hasLoadedMore && (isLastTwo ? 0.3 : isNextToAnimate && 0.25),
        delay:
          hasLoadedMore && (isLastTwo ? 0.1 : isNextToAnimate && (listLength - index) * 0.0015),
      }}
    >
      {children}
    </motion.li>
  )
}
